if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.carts = [document.querySelector('cart-notification'), document.querySelector('cart-drawer')].filter(
          Boolean
        );
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const productAvailable = this.variantIdInput.dataset.productAvailable === 'true';

        if (!productAvailable) {
          window.location.href = this.variantIdInput.dataset.productUrl;
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = SF.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.carts.length > 0) {
          formData.append(
            'sections',
            this.carts.flatMap((cart) => cart.getSectionsToRender()).map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.carts.forEach((cart) => cart.setActiveElement(document.activeElement));
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.carts.length) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.carts.forEach((cart) => cart.renderContents(response));
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.carts.forEach((cart) => cart.renderContents(response));
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.carts.forEach((cart) => {
              if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            });
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            /* for confetti script */
            const added_cart = new CustomEvent('SF_added_to_cart');
            window.dispatchEvent(added_cart);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );

  class SF_LiteSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.sf-media-carousel__list');
      this.sliderItems = this.querySelectorAll('.sf-media-carousel__item');
      this.prevButton = this.querySelector('button[name="previous"].slider-button');
      this.nextButton = this.querySelector('button[name="next"].slider-button');
      this.currentSlide = this.querySelector('.sf-media-carousel__item--active');
      this.currentPage = 0;

      if (!this.slider || !this.nextButton) return;

      this.init();
      this.attachListeners();
    }

    init() {
      if (!this.currentSlide) {
        this.currentPage = 0;
        this.sliderItems[this.currentPage].classList.add('sf-media-carousel__item--active');
      }

      if (this.sliderItems.length < 2) return;
      this.prevButton.removeAttribute('disabled');
      this.nextButton.removeAttribute('disabled');
    }

    attachListeners() {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!event.currentTarget.name) {
        console.warn('Button name attribute not found');
        return;
      }

      let position = 0;

      if (event.currentTarget.name === 'next') {
        this.currentPage === this.sliderItems.length - 1 ? (position = 0) : (position = this.currentPage + 1);
        this.setSlidePosition(position);
      } else if (event.currentTarget.name === 'previous') {
        this.currentPage === 0 ? (position = this.sliderItems.length - 1) : (position = this.currentPage - 1);
        this.setSlidePosition(position);
      }
    }

    setSlidePosition(position) {
      this.sliderItems.forEach((element) => {
        element.classList.remove('sf-media-carousel__item--active');
      });

      this.sliderItems[position].classList.add('sf-media-carousel__item--active');
      this.currentPage = position; // Safety net
    }
  }

  customElements.define('sf-lite-slider', SF_LiteSlider);
}
